<template>
  <b-modal
    :id="id"
    cancel-title="Annulla"
    cancel-variant="outline-secondary"
    centered
    :ok-disabled="okDisabled"
    :cancel-disabled="submitting"
    :no-close-on-backdrop="submitting"
    :no-close-on-esc="submitting"
    :hide-header-close="submitting"
    ok-title="Sposta"
    :title="title"
    class="modal-dialog"
    @ok="moveOrRestore"
    @show="setup"
  >
    <MyLoading :loading-show="loadingShow" />
    <BButton
      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
      class="my-button mb-1"
      variant="outline-secondary"
      @click="goHome"
    >
      <FontAwesomeIcon icon="home" />
    </BButton>
    <b-form>
      <b-form-group>
        <b-table
          :items="list"
          :fields="fields"
          select-mode="single"
          selectable
          selected-variant="primary"
          @row-dblclicked="doubleClick"
          @row-selected="onRowSelected"
        />
      </b-form-group>
    </b-form></b-modal>
</template>

<script>
import {
  BButton, BForm, BFormGroup, BModal, BTable,
} from 'bootstrap-vue'
import objectsRepository from '@/api/objectsRepository'
import useMyStore from '@/services/useMyStore'
import Ripple from 'vue-ripple-directive'
import MyLoading from '@/layouts/components/MyLoading.vue'
import restoreResults from '@/helpers/restore-results'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'Modal',
  directives: {
    Ripple,
  },
  components: {
    MyLoading,
    BButton,
    BModal,
    BForm,
    BFormGroup,
    BTable,
  },
  props: {
    selectedFiles: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: () => false,
    },
    id: {
      type: String,
      default: () => 'move-modal',
    },
    trashed: {
      type: Boolean,
      default: () => false,
    },
    trashedIds: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { currentObject, currentFolder } = useMyStore()
    return { currentObject, currentFolder }
  },
  data() {
    return {
      label: '',
      fields: [{ key: 'label', label: 'Cartelle' }],
      list: [],
      fatherId: null,
      selectedFather: [],
      loadingShow: false,
      submitting: false,
    }
  },
  computed: {
    selected_ids() {
      if (this.selectedFiles.find(el => el.id === this.currentObject) || this.multiple) {
        return this.commonHelpers.pluck(this.selectedFiles, 'id')
      }
      return [this.currentObject]
    },
    restoreIds() {
      const ids = restoreResults.uniqueIds(this.trashedIds)
      if (ids.includes(this.currentObject)) {
        return ids
      }
      if (this.currentObject !== null && this.currentObject !== undefined) {
        return [this.currentObject]
      }
      return []
    },
    okDisabled() {
      return !this.fatherId || this.submitting
    },
    title() {
      if (this.multiple) {
        return 'Sposta Files'
      } if (this.trashed) {
        return 'Ripristina File'
      }
      return 'Sposta File'
    },
  },
  created() {
    // this.fatherId = null
    // this.getFoldersList()
  },
  methods: {
    setup() {
      this.fatherId = null
      this.submitting = false
      this.getFoldersList()
    },
    async getFoldersList() {
      this.loadingShow = true
      const { data } = await objectsRepository.getDirs(this.fatherId)
      if (data.code) {
        this.list = data.data.dirs
      }

      this.loadingShow = false
    },
    moveOrRestore(bvModalEvt) {
      if (this.trashed) {
        bvModalEvt.preventDefault()
        if (this.fatherId) {
          this.restore()
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Seleziona una cartella.',
              icon: 'ErrorIcon',
              variant: 'error',
            },
          },
          {
            position: 'top-center',
          })
        }
        return
      }
      if (this.fatherId) {
        this.move()
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Seleziona una cartella.',
            icon: 'ErrorIcon',
            variant: 'error',
          },
        },
        {
          position: 'top-center',
        })
      }
    },
    async move() {
      const { data } = await objectsRepository.move({
        ids: this.selected_ids,
        father_id: this.fatherId,
      })

      if (data.code) {
        this.$emit('moved')
      } else {
        console.log('error update folder')
      }
    },
    async restore() {
      if (this.submitting) {
        return
      }
      const ids = this.restoreIds
      if (ids.length === 0) {
        this.$bvModal.hide(this.id)
        return
      }
      this.loadingShow = true
      this.submitting = true
      try {
        const results = await Promise.allSettled(
          ids.map(id => objectsRepository.restore(id, { father_id: this.fatherId })),
        )
        const summary = restoreResults.summarizeRestoreResults(ids, results)
        if (summary.toast) {
          this.$toast(
            { component: ToastificationContent, props: summary.toast },
            { position: 'top-center' },
          )
          if (summary.failures.length > 0) {
            summary.failures.forEach(failure => this.apiErrors.logApiError(failure.failure))
          }
        } else if (summary.singleFailure) {
          this.apiErrors.notifyApiError(summary.singleFailure, restoreResults.RESTORE_ERROR_OVERRIDES)
        }
        if (summary.restoredObjects.length > 0) {
          this.$emit('restored', { restoredObjects: summary.restoredObjects, fatherId: this.fatherId })
        }
      } finally {
        this.loadingShow = false
        this.submitting = false
        this.$nextTick(() => this.$bvModal.hide(this.id))
      }
    },
    doubleClick(row) {
      this.fatherId = row.id
      this.getFoldersList()
    },
    onRowSelected(items) {
      this.selectedFather = items
      if (items.length === 1) {
        this.fatherId = items[0].id
      } else {
        this.fatherId = null
      }
      // console.log("select father id => " + items[0].id);
    },
    goHome() {
      this.fatherId = null
      this.getFoldersList()
    },
    close() {
      this.fatherId = null
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
[dir="ltr"] .modal-header .close {
  margin: -0.5rem -0.6rem -0.5rem auto;
}
.table > tbody > tr.b-row-selected {
  background-color: red;
}
.my-button {
  padding: 0.5rem 0.9rem;
}

</style>
